module.exports = __webpack_public_path__ + "img/coSpectro.d4a42d83.png";